import type { ProductSummary } from '../types/product.types';

// A bundle has no category or author of its own (the API returns null)
export const BUNDLE_CATEGORY_LABEL = 'Semua Kategori';
export const BUNDLE_AUTHOR_LABEL = 'Berbagai Penulis';

type Labelled = Pick<ProductSummary, 'product_type' | 'category' | 'author'>;

export const categoryLabel = (product: Labelled) =>
  product.product_type === 'bundle' ? BUNDLE_CATEGORY_LABEL : (product.category?.name ?? null);

export const authorLabel = (product: Pick<Labelled, 'product_type' | 'author'>) =>
  product.product_type === 'bundle' ? BUNDLE_AUTHOR_LABEL : product.author;
